<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Produk Saya</h2>

    <v-card outlined class="px-3 py-3">
      <v-tabs v-model="tab" show-arrows @change="selectTab">
        <v-tab class="text-caption font-weight-bold">Semua</v-tab>
        <v-tab class="text-caption font-weight-bold">Live</v-tab>
        <v-tab class="text-caption font-weight-bold">Habis</v-tab>
        <v-tab class="text-caption font-weight-bold">Direview</v-tab>
        <v-tab class="text-caption font-weight-bold">Ditolak</v-tab>
        <v-tab class="text-caption font-weight-bold" v-if="false">Diarsipkan</v-tab>

        <v-tab-item>
          <produkData type="all" v-if="tab == 0"></produkData>
        </v-tab-item>

        <v-tab-item>
          <produkData type="live" v-if="tab == 1"></produkData>
        </v-tab-item>
        <v-tab-item>
          <produkData type="sold-out" v-if="tab == 2"></produkData>
        </v-tab-item>
        <v-tab-item>
          <produkData type="direview" v-if="tab == 3"></produkData>
        </v-tab-item>
        <v-tab-item>
          <produkData type="ditolak" v-if="tab == 4"></produkData>
        </v-tab-item>
 
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import produkData from "./components/produkAll";
// import produkLive from './components/produkLive'
// import produkSold from './components/produkSold'
// import produkArchived from './components/produkArchived'

export default {
  components: {
    produkData
    // produkLive, produkSold, produkArchived
  },
  data() {
    return {
      tab: 1
    };
  },
  methods: {
    ...mapActions("category", ["getCategory"]),

    selectTab(val) {
      this.tab = val;
    }
  },
  created() {
    this.getCategory();
  },
  mounted(){
    let tab = this.$route.query.type
    if(tab == 'live') this.tab = 1
    if(tab == 'habis') this.tab = 2
  }
};
</script>